import { connect } from "react-redux";
import Component from "../components/AppModal";
import { setUIVisibilityState } from "../actions";
var mapStateToProps = function(state, ownProps) {
    return {
        currentSlide: state.currentSlide,
        visible: state.uiVisibilityState.modal,
        content: null
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        close: function() {
            dispatch(setUIVisibilityState({
                state: {
                    modal: false
                }
            }));
        },
        show: function() {
            dispatch(setUIVisibilityState({
                state: {
                    modal: true
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
